import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { LazyElementsModule } from '@angular-extensions/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { AppMaterialModule } from 'src/app/app-material.module';
import { CMSComponent } from './components/cms/cms.component';
import { EditorComponent } from './components/editor/editor.component';

@NgModule({
  declarations: [
    CMSComponent,
    EditorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyElementsModule,
    MatChipsModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    AppMaterialModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class CMSModule { }
